import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FocusableNoopAnchorDirective } from '@ftr/foundation'
import { UpdateAppToastComponent } from './update-app-toast.component'

@NgModule({
  imports: [CommonModule, FocusableNoopAnchorDirective],
  declarations: [UpdateAppToastComponent],
  exports: [UpdateAppToastComponent],
})
export class UpdateAppToastModule {}
